import { createSlice } from '@reduxjs/toolkit';
import { TripEntity } from '@interpals/api-web';

import { fetchTrips, createTrip, editTrip, deleteTrip } from './actions';

export interface TripsState {
    data: TripEntity[];
}

const initialState: TripsState = {
    data: [],
};

const tripsSlice = createSlice({
    name: 'trips',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTrips.fulfilled, (state, { payload }) => {
            state.data = payload;
        });
        builder.addCase(createTrip.fulfilled, (state, { payload }) => {
            state.data = state.data ? [payload, ...state.data] : [payload];
        });
        builder.addCase(editTrip.fulfilled, (state, { payload }) => {
            state.data = state.data.map((item) => (item.id === payload?.id ? { ...item, ...payload } : item));
        });
        builder.addCase(deleteTrip.fulfilled, (state, { payload }) => {
            state.data = state.data?.filter((trip) => trip.id !== payload);
        });
    },
});

export default tripsSlice.reducer;
